import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/Users/kei/repos/opera-lang/src/components/Layout.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Note = makeShortcode("Note");
const Ex = makeShortcode("Ex");
const Tr = makeShortcode("Tr");
const LyricSeparator = makeShortcode("LyricSeparator");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`プロヴァンスの海と陸`}</h1>
    <div style={{
      padding: 16,
      margin: 8,
      border: '1px solid orange'
    }}>
  こちらのコンテンツは新しいサイトに移行しています。以下のリンクから新サイトをご覧ください。
  <div style={{
        margin: 16,
        textAlign: "center",
        overflowWrap: "break-word"
      }}>
    <a href="https://capriccioso.info/opera/la-traviata/di-provenza-il-mar">https://capriccioso.info/opera/la-traviata/di-provenza-il-mar</a>
  </div>
    </div>
    <h4>{`Di provenza il mar, il suol`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#youtube"
        }}>{`Youtube の動画`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#translation"
        }}>{`対訳と語義解説`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#sheet"
        }}>{`楽譜`}</a></li>
    </ul>
    <h2 name="youtube">Youtube の動画</h2>
    <h4>{`Dmitri Hvorostovsky✬♫ "Di Provenza il mar, il suol"/Giorgio Germont 'La Traviata'`}</h4>
    <iframe width="100%" height="315" src="https://www.youtube.com/embed/gbJYvh8D1Rc" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
    <h4>{`Di provenza il mar, il suol - La Traviata - Renato Bruson y Scott Piper`}</h4>
    <iframe width="100%" height="315" src="https://www.youtube.com/embed/l-hwlLh7t9M?start=40" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
    <h2 name="translation">対訳と語義解説</h2>
    <Note mdxType="Note">単語をクリック（タップ）すると解説が表示されます。</Note>
    <p>
  Di <Ex m="プロヴァンス地方" mdxType="Ex">Provenza</Ex> <Ex m="海" o="mare" mdxType="Ex">il mar</Ex>, <Ex m="地表、大地" o="suolo" mdxType="Ex">il suol</Ex>
    </p>
    <Tr mdxType="Tr">プロヴァンスの海と大地を</Tr>
    <p>
  <Ex m="誰が" mdxType="Ex">chi</Ex> <Ex m="da（〜から） + il" mdxType="Ex">dal</Ex> <Ex m="心臓、心（詩語。 = cuore）" mdxType="Ex">cor</Ex> <Ex m="このtiは間接目的語「君に、君から」" mdxType="Ex">ti</Ex> <Ex m="消す（遠過去）" o="cancellare" mdxType="Ex">cancellò</Ex>? chi dal cor ti cancellò?
    </p>
    <Tr mdxType="Tr">誰がお前の心から消し去ってしまったのだ？</Tr>
    <p>
  di Provenza il mar, il suol?
    </p>
    <Tr mdxType="Tr">プロヴァンスの海と大地を</Tr>
    <p>
  <Ex m="a + il （この a は動詞 furare 「盗む」の対象（盗む相手）を表す）" mdxType="Ex">Al</Ex> <Ex m="出生の、故郷の (= nativo)" mdxType="Ex">natio</Ex> <Ex m="光り輝く" mdxType="Ex">fulgente</Ex> <Ex m="太陽" o="sole" mdxType="Ex">sol</Ex>
    </p>
    <Tr mdxType="Tr">故郷の輝く太陽から</Tr>
    <p>
  <Ex m="どのような" o="quale" mdxType="Ex">qual</Ex> <Ex m="運命" mdxType="Ex">destino</Ex> <Ex m="君を（直接目的語）" mdxType="Ex">ti</Ex> <Ex m="盗む（遠過去）（古語）" o="furare" mdxType="Ex">furò</Ex>? qual destino ti furò?
    </p>
    <Tr mdxType="Tr">どのような運命がお前を奪ったのだ？</Tr>
    <p>
  al natio fulgente sol?
    </p>
    <Tr mdxType="Tr">故郷の輝く太陽から</Tr>
    <p>
  Oh, <Ex m="覚えている、思い出させる（命令法）" o="rammentare" mdxType="Ex">rammenta</Ex> <Ex m="たとえ〜であっても" o="pure" mdxType="Ex">pur</Ex> <Ex m="in（〜の中に） + il" mdxType="Ex">nel</Ex> <Ex m="悲しみ、苦悩" o="duolo" mdxType="Ex">duol</Ex>
    </p>
    <Tr mdxType="Tr">おお、たとえ苦悩の中にあっても思い出しなさい</Tr>
    <p>
  <Ex m="〜ということ（接続詞。英語のthatに相当）" o="che" mdxType="Ex">ch'</Ex><Ex m="そこに" mdxType="Ex">ivi</Ex> <Ex m="喜び（現在ではgioiaと書く）" mdxType="Ex">gioja</Ex> a te <Ex m="輝く（遠過去）" o="brillare" mdxType="Ex">brillò</Ex>;
    </p>
    <Tr mdxType="Tr">そこではお前に喜びが輝いていたことを</Tr>
    <p>
  E <Ex m="このcheは前行のch'と並列になっている" mdxType="Ex">che</Ex> <Ex m="平和" mdxType="Ex">pace</Ex> <Ex m="かなたで、向こうに" mdxType="Ex">colà</Ex> <Ex m="ただ〜だけ" o="solo" mdxType="Ex">sol</Ex>
    </p>
    <Tr mdxType="Tr">そして、そこでだけ、平和は</Tr>
    <p>
  <Ex m="〜の上に" mdxType="Ex">su</Ex> te <Ex m="輝く" mdxType="Ex">splendere</Ex> <Ex m="まだ、相変わらず、もう一度" o="ancora" mdxType="Ex">ancor</Ex> <Ex m="〜することができる" o="potere" mdxType="Ex">può</Ex>
    </p>
    <Tr mdxType="Tr">お前の上にもう一度輝くことができるのだということを</Tr>
    <p>
  e che pace colà sol
    </p>
    <Tr mdxType="Tr">そして、そこでだけ、平和は</Tr>
    <p>
  su te splendere ancor può
    </p>
    <Tr mdxType="Tr">お前の上にもう一度輝くことができるのだということを</Tr>
    <p>
  <Ex m="神" mdxType="Ex">Dio</Ex> mi <Ex m="案内する、導く（遠過去）" o="guidare" mdxType="Ex">guidò</Ex>! Dio mi guidò! Dio mi guidò!
    </p>
    <Tr mdxType="Tr">神様が私をお導きくださったのだ！</Tr>
  
    <LyricSeparator mdxType="LyricSeparator" />
    <p>
  Ah! il <Ex m="君の" mdxType="Ex">tuo</Ex> <Ex m="年取った" mdxType="Ex">vecchio</Ex> <Ex m="父親" o="genitore" mdxType="Ex">genitor</Ex>
    </p>
    <Tr mdxType="Tr">ああ！ お前の年老いた父親が</Tr>
    <p>
  tu non <Ex m="知っている" o="sapere" mdxType="Ex">sai</Ex> <Ex m="どれだけ" mdxType="Ex">quanto</Ex> <Ex m="苦しむ（遠過去）" o="soffrire" mdxType="Ex">soffrì</Ex>... tu non sai quanto soffrì
    </p>
    <Tr mdxType="Tr">どれほど苦しんだかお前は知るまい</Tr>
    <p>
  il tuo vecchio genitor!
    </p>
    <Tr mdxType="Tr">お前の年老いた父親が！</Tr>
    <p>
  Te <Ex m="遠い" mdxType="Ex">lontano</Ex>, di <Ex m="侘しさ、惨めさ" o="squallore" mdxType="Ex">squallor</Ex>
    </p>
    <Tr mdxType="Tr">お前が去って、惨めさに</Tr>
    <p>
  il <Ex m="彼の" mdxType="Ex">suo</Ex> <Ex m="屋根、家" mdxType="Ex">tetto</Ex> <Ex m="(di) 〜で覆われる（遠過去）" o="coprirsi" mdxType="Ex">si coprì</Ex>... il suo tetto si coprì
    </p>
    <Tr mdxType="Tr">彼の家は覆われてしまった</Tr>
    <p>
  di squallor, di squallor...
    </p>
    <Tr mdxType="Tr">惨めさに…</Tr>
    <p>
  <Ex m="しかし" mdxType="Ex">Ma</Ex> <Ex m="〜する以上、〜だから" mdxType="Ex">se</Ex> <Ex m="最後に、ついに" o="alfine" mdxType="Ex">alfin</Ex> ti <Ex m="見つける" o="trovare" mdxType="Ex">trovo</Ex> <Ex m="もう一度" o="ancora" mdxType="Ex">ancor</Ex>,
    </p>
    <Tr mdxType="Tr">だが、ついにお前をもう一度見つけたのだから</Tr>
    <p>
  se in me <Ex m="希望" mdxType="Ex">speme</Ex> non <Ex m="失敗する" o="fallire" mdxType="Ex">fallì</Ex>
    </p>
    <Tr mdxType="Tr">私の希望は消えなかったのだから</Tr>
    <p>
  Se <Ex m="声" mdxType="Ex">la voce</Ex> dell'<Ex m="名誉" o="onore" mdxType="Ex">onor</Ex>
    </p>
    <Tr mdxType="Tr">名誉の声が</Tr>
    <p>
  in te <Ex m="十分に、全く、すっかり" o="appieno" mdxType="Ex">appien</Ex> non <Ex m="口をつぐむ（遠過去）(= ammutolire)" o="ammutire" mdxType="Ex">ammutì</Ex>,
    </p>
    <Tr mdxType="Tr">お前の中で完全に沈黙してしまったのではなかったのだから</Tr>
    <p>
  ma se alfin ti trovo ancor,
    </p>
    <Tr mdxType="Tr">だが、ついにお前をもう一度見つけたのだから</Tr>
    <p>
  se in me speme non fallì
    </p>
    <Tr mdxType="Tr">私の希望は消えなかったのだから</Tr>
    <p>
  Dio m'<Ex m="（神が祈りや願いを）かなえる、聞き届ける（遠過去）" mdxType="Ex">esaudì</Ex>! Dio m'esaudì! Dio m'esaudì! Dio m'esaudì!
    </p>
    <Tr mdxType="Tr">神が私の願いを聞き届けてくださったのだ！</Tr>
    <p>
  ma... ma se alfin ti trovo ancor, ti trovo ancor,
    </p>
    <Tr mdxType="Tr">だが、ついにお前をもう一度見つけたのだから</Tr>
    <p>
  Dio m'esaudì! Dio m'esaudì!
    </p>
    <Tr mdxType="Tr">神が私の願いを聞き届けてくださったのだ！</Tr>
    <h2 name="sheet">楽譜</h2>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "800px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/38464760499940de54e0c3a9816839f4/8698d/traviata-di-provenza-il-mar.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "190.5%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAmCAYAAADEO7urAAAACXBIWXMAABcSAAAXEgFnn9JSAAADp0lEQVRIx63W124rMQxFUf//ryUI0nvvvfemi0XgCOM4bzcGZGlUzyYpzozaf/4+Pj7a29tbe39/b9/f323k7/7+vr2+vrbb29t2cHBQ5ejoqF1eXtaYen9/vx0fH7fn5+f28PDQbm5u2snJSfVfX1+3q6ur2rw2XF1dbQsLC219fb1tbm5Wvbi42NbW1qq9vb3dlpeX29TUVNvY2Gjz8/NVmzM9Pd12dnaq7+XlpY1+yncABIo/Pz8L5evrq497zjy/4Cp+I5PJhXF+fl7l6empTjs7O2uHh4elENrd3V2ZIP2UMYe5Y8iw4K2srFR7aWmpNtjd3S27WQiRbW20tbVVtflMpG39BLIOCArcIZYxfakV/QiZR7sjQ4iHnX5xcVEmgBM8zzazGLZ5iQQmOT09rUMKmexI502Iij6T4WjrY5KgGhM61hFD5RgytUFVe+a9x8fHMrjnREA8q511HTnSOcFJ5NtEoQSevr29vVLDDNocxvOeqe/INiJfJ+8qNuBZuPotYluHGw+mfqFmrMJmiMzYrlYQE9zKMOjNU6jjqERIR44i18cV5BjKKFdTJdipcv2g5qqai85aYgqZ9Fz+1LxnIlsp1HhmhoSTg9jXRTAH0RhyAvmn5+EOn4cR8fNXyNDgMCxlTk2gc8jc3FxlJAr1QaU0uNKXeRWHVEE00YY8lhxnEtsaz73OzdGfqEgYicvREPM3hN/6E+BJWUNzFXKyRwwctQl0tSJLU0UNr+Y6mgu9nGJn8tnOQBCCoV/NZpDNZQ6e1nagg8yfQJZREtRBE7Dia4gd5LygJpB5jQoIs7Oz1aYUDu/KLmKOIqYxHo+jSulelr5513XKvVRDMZZ7rC+5L+HFDMnq/RWQX16RjKvAzz32PAxsYwSwm3UZL2RIMLwW4fMoBfph5a4muxifmZnp7xnj+jqyewqD59Km1G1JvrMAPnSIxpjAuMRh7QTy8AUFIwdAy6uVXbWDaxMHea5PEciCmYGlpHiUx3kYqhSWzGPcfF8MmSelQe9x6ESnJHCdBkkAM37wqVMS2NZ5ZgZr+isg3ksWtjjvXxsmwZpjfg4YZmt27l7Oh1G+ENTDDyXPkGwisJmCifQhS9AXsl0TcxyiznWjKm8/z/lKQEFl+vKq7d+HuYvCIEkidlRbnAC30DzKElYEjN1lyLzFDjzNg5Dc60QAJGMCOok1iRmyNgcVciTHowbiVTU18LUdmmuX7JQMNeblv/qNYr+/Kv8Adww+1Wyqdj4AAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "楽譜",
            "title": "楽譜",
            "src": "/static/38464760499940de54e0c3a9816839f4/5a190/traviata-di-provenza-il-mar.png",
            "srcSet": ["/static/38464760499940de54e0c3a9816839f4/772e8/traviata-di-provenza-il-mar.png 200w", "/static/38464760499940de54e0c3a9816839f4/e17e5/traviata-di-provenza-il-mar.png 400w", "/static/38464760499940de54e0c3a9816839f4/5a190/traviata-di-provenza-il-mar.png 800w", "/static/38464760499940de54e0c3a9816839f4/c1b63/traviata-di-provenza-il-mar.png 1200w", "/static/38464760499940de54e0c3a9816839f4/8698d/traviata-di-provenza-il-mar.png 1239w"],
            "sizes": "(max-width: 800px) 100vw, 800px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      